import { BasePage } from '@/components/ui/base-page'

export function ETPPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add ETPPage specific content here */}
    </BasePage>
  )
}